if (!customElements.get('product-fixed-bar')) {
  customElements.define(
    'product-fixed-bar',
    // eslint-disable-next-line no-undef
    class ProductFixedBar extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.isPermanentlyClosed = false
      }

      setupListeners () {
        super.setupListeners()

        if (!this.hasExternalEl('mainProductForm')) return

        this.onScroll = this.onScroll.bind(this)
        this.listeners.add(document, 'DOMContentLoaded', this.onScroll)
        this.listeners.add(window, 'scroll', this.onScroll)

        this.handleScrollBackClick = this.handleScrollBackClick.bind(this)
        this.listeners.add(this, 'click', this.handleScrollBackClick)

        if (this.hasEl('close')) {
          this.handleClose = this.handleClose.bind(this)
          this.listeners.add(this, 'click', this.handleClose)
        }
      }

      onScroll () {
        if (this.isPermanentlyClosed) return

        if (this.hasExternalEl('quickBuyContainer')) {
          this.externalEls.quickBuyContainer.element.setAttribute(
            'aria-hidden',
            'true',
          )
        }

        const y = window.scrollY
        y >= 1030
          ? document.body.classList.add('product-fixed-bar-active')
          : document.body.classList.remove('product-fixed-bar-active')

        y >= 1030
          ? this.setAttribute('aria-hidden', 'false')
          : this.setAttribute('aria-hidden', 'true')
      }

      handleClose (event) {
        const closeEl = event.target.closest(this.els.close.selector)
        if (!closeEl) return
        this.isPermanentlyClosed = true
        this.setAttribute('aria-hidden', 'true')
      }

      handleScrollBackClick (event) {
        const fixedButtonEl = event.target.closest(
          this.els.fixedButton.selector,
        )
        if (!fixedButtonEl) return

        window.scrollTo({
          top: this.getOffsetTop(this.externalEls.mainProductForm.element) - 90,
          behavior: 'smooth',
        })
      }

      getOffsetTop (el, parent = document.body, offsetTop = 0) {
        if (!el) return offsetTop

        if (!isNaN(el.offsetTop)) {
          offsetTop += el.offsetTop
        }

        return el.offsetParent === parent
          ? offsetTop
          : this.getOffsetTop(el.offsetParent, parent, offsetTop)
      }

      hasEl (elementName) {
        return this.els[elementName] && this.els[elementName].exists
      }

      hasExternalEl (elementName) {
        return (
          this.externalEls[elementName] && this.externalEls[elementName].exists
        )
      }

      set isPermanentlyClosed (boolean) {
        this._isPermanentlyClosed = boolean
      }

      get isPermanentlyClosed () {
        return this._isPermanentlyClosed
      }
    },
  )
}
